// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QEwP","placeholdersHeader":"styles_placeholdersHeader__1bbxk","editorStyle":"styles_editorStyle__1p71T","placeholdersBox":"styles_placeholdersBox__1M74J"};